import { FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { useAuth } from 'modules/common/hooks/useAuth';

export const PrivateOutlet: FC = () => {
  const auth = useAuth();
  return auth ? <Outlet /> : <Navigate to="/auth/login" />;
};
